import { use } from "react";
import { TranslationsContext } from "./TranslationsContext";

export function useTranslations() {
  const context = use(TranslationsContext);

  if (!context) {
    throw new Error(
      "useTranslations must be used within a ComponentsLocaleProvider",
    );
  }

  return context;
}
